'use client';

import Image from 'next/image';
import {useContext} from 'react';
import {ThemeContext} from '../../utils/ThemeContext';

const Dashboards = ({data}) => {
  const {theme} = useContext(ThemeContext);
  const {id, subtitle, color, title, list, image, imageLight} = data;
  const imgSrc = theme === 'dark' ? image : imageLight;
  const imgStyle = {backgroundImage: `url(${imgSrc})`};

  const listItems = list.map((item, index) => {
    const {listTitle, listText} = item;
    return (
      <li className='list-item' key={index}>
        <strong>{listTitle}</strong> {listText}
      </li>
    );
  });

  return (
    <section className={`dashboards ${id}`} id={id}>
      <div className='container'>
        <div className='inner-container'>
          <h3 className={`subtitle ${color}`}>{subtitle}</h3>
          <h2 className='title'>{title}</h2>
          <ul className='list'>{listItems}</ul>
          <div className='img-container'>
            <div className='img' style={imgStyle} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dashboards;

